<template>
  <MainLayout>
    <template v-slot:toolbar>
      <div class="d-block w-100">
        <div class="mt-1">
          <AlertWraper
            :content="error"
            type="error"
          />
          <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-inline-flex">
              <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Gerenciar Audiências</h1>
            </div>
            <!--end::Title-->
          </div>

          <div class="card card-flush mt-5">
            <div class="card-body">
              <div class="description fs-6 mt-3">
                <p class=""> Faça o upload de um arquivo (.csv) para gerenciar as audiências salvas no sistema.</p>
                <p>A partir do momento em que enviar uma nova planilha, todas as audiências serão desativadas no sistema, mantendo ativas somente as audiências incluidas na planilha enviada.</p>
                <p>Siga o exemplo abaixo:</p>
              </div>
              <!--begin::File Sample-->
              <div class="m-auto w-75 mt-5 mb-4">
                <table class="excel-table">
                  <thead>
                  <tr>
                    <th>name</th>
                    <th>id</th>
                    <th>type</th>
                    <th>audience_size</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Board Games</td>
                    <td>12345</td>
                    <td>THIRD_PARTY</td>
                    <td>1554540</td>
                  </tr>
                  <tr>
                    <td>In Market Audience</td>
                    <td>67890</td>
                    <td>-vazio- <br/><small>(se tiver vazio será considerado Google Audiences)</small></td>
                    <td>1562255</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--end::File Sample-->

              <div class="mt-5">
                <!--begin::Form-->
                <form class="default-form" @submit.prevent="">
                  <LoaderOverlay
                    size="big"
                    color="color2"
                    v-if="loader"
                  />
                  <div class="d-flex align-items-center gap-3">
                    <div class="col-5">
                      <label class="form-label required fw-semibold mb-0 me-2" for="file"> Selecione um arquivo</label>
                      <input type="file" accept=".csv" id="file" @change="setFile" class="form-control my-2">
                      <div
                        class="progress"
                        role="progressbar"
                        aria-label="Animated striped example"
                        :aria-valuenow="uploadProgress"
                        aria-valuemin="0"
                        aria-valuemax="100"
                        :value="uploadProgress"
                      >
                        <div
                          class="progress-bar bg-primary progress-bar-striped progress-bar-animated"
                          :style="{ width: uploadProgress + '%' }"
                        >{{ uploadProgress + '%' }}</div>
                      </div>
                    </div>
                    <div>
                      <div class="form-check mb-3">
                        <input class="form-check-input" type="radio" v-model.trim="form.type_import" name="flexRadioDefault" id="flexRadioDefault1" value="FULL">
                        <label class="form-check-label" for="flexRadioDefault1">
                          Planilha completa (todas as audiências)
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" v-model.trim="form.type_import" name="flexRadioDefault" id="flexRadioDefault2" value="PARTIAL" checked>
                        <label class="form-check-label" for="flexRadioDefault2">
                          Planilha parcial (somente audiências novas)
                        </label>
                      </div>
                    </div>
                  </div>
                </form>
                <!--end::Form-->
              </div>

            </div>
            <!--begin:Action-->
            <div class="mt-3 mb-5 text-center">
              <Button
                class="btn btn-primary"
                @click="submit"
                :loading="loader"
                :disabled="!form.file"
              >
                Salvar
              </Button>
            </div>
            <!--end:Action-->
          </div>
        </div>
      </div>
    </template>
  </MainLayout>
</template>
<script>
import Audiences from '@/modules/audiences/services/audiences-service'
import Button from '@/components/common/Button/Button'
import NotificationService from '@/modules/notifications/services/notifications-service'
import MainLayout from '@/components/layouts/MainLayout'
import AlertWraper from '@/components/common/Alert/AlertWraper'
import { parseErrorResponseToArray } from '@/utils'
import LoaderOverlay from '@/components/common/Loader/LoaderOverlay'

export default {
  name: 'AudienceEdit',
  components: {
    LoaderOverlay,
    AlertWraper,
    MainLayout,
    Button
  },
  data () {
    return {
      error: null,
      form: {
        file: null,
        total_chunks: 0,
        type_import: null
      },
      loader: false,
      table: [
        {
          name: 'Exemplo 1',
          id: 12345,
          type: 'THIRD_PARTY',
          priority: 10,
          platform: 'GOOGLE'
        },
        {
          name: 'Exemplo 2',
          id: 12345,
          type: 'PLATFORM_DATA',
          priority: 10,
          platform: 'GOOGLE'
        }
      ],
      uploadProgress: 0
    }
  },
  methods: {
    /**
     * delay
     */
    delay (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    /*
     *  Submits form
     */
    async submit () {
      this.loader = true

      try {
        await Audiences.upsertAudiences(this.form)
        const notification = {
          notification: {
            type: 'success',
            content: 'Arquivo recebido com sucesso!'
          }
        }

        NotificationService.createGlobalSuccessNotification(notification)
        setTimeout(() => {
          location.reload()
        }, 3500)
      } catch (error) {
        this.error = parseErrorResponseToArray(error)
      }
      this.loader = false
    },
    /**
     * Sets file to form data
     */
    async setFile (e) {
      const file = e.target.files[0]

      this.uploadProgress = 0
      const CHUNK_SIZE = 1024 * 1024 // 1MB
      const totalChunks = Math.ceil(file.size / CHUNK_SIZE)
      const fileId = `${file.name}-${Date.now()}_${Math.random().toString(36).substring(2, 9)}`
      this.form.total_chunks = totalChunks

      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        const start = chunkIndex * CHUNK_SIZE
        const end = Math.min(file.size, start + CHUNK_SIZE)
        const chunk = file.slice(start, end)

        try {
          await this.uploadWithRetry({
            chunk: chunk,
            fileId: fileId,
            chunkIndex: chunkIndex,
            totalChunks: totalChunks,
            fileName: file.name
          })
        } catch (error) {
          this.error = parseErrorResponseToArray(error)
        }

        this.uploadProgress = Math.round(((chunkIndex + 1) / totalChunks) * 100)
        await this.delay(1000)
      }
      this.form.file = fileId
    },
    /**
     * upload with retry
     */
    async uploadWithRetry (params, retries = 3, delayMs = 1000) {
      for (let attempt = 0; attempt < retries; attempt++) {
        try {
          await Audiences.uploadFileChunk(params)
          return // Sucesso, sai da função
        } catch (error) {
          if (error.response?.status === 429 && attempt < retries - 1) {
            console.warn(`429 recebido. Tentando novamente em ${delayMs}ms...`)
            await this.delay(delayMs)
            delayMs *= 2 // Backoff exponencial
          } else {
            throw error // Se não for 429 ou se acabou as tentativas
          }
        }
      }
    }
  }
}
</script>
<style scoped>

.excel-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}
.excel-table th, .excel-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}
.excel-table th {
  background-color: #f9f9f9;
  color: black;
  font-weight: bold;
}
.excel-table tr:nth-child(even) {
  background-color: #f9f9f9;
}
</style>
